import {Box, Typography} from '@mui/material';
import {Page, PageSeo, PageType} from '../../components/common/container';

import {EmailWasSentMessage} from '../../components/common/supportMailSent';
import {GetStaticProps} from 'next';
import {ImportantLink} from '../../components/common/button';
import {SupportCategory} from '../../types';
import SupportForm from '../../components/help/SupportForm';
import {Title} from '../../components/common/text';
import {URL_SERVER_INTERNAL} from '../../utils/settings';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {useGetSupport} from '../../queries/helpQueries';
import {useState} from 'react';
import {useTranslation} from 'next-i18next';

export default function Support(props: SupportStaticProps) {
    const {t} = useTranslation('common');
    const {data} = useGetSupport(props.data);
    const [wasSent, setWasSent] = useState(false);

    return (
        <Page>
            <PageSeo page={PageType.SUPPORT} />
            <Title>{t('title.support')}</Title>
            <Box sx={{marginTop: '50px', textAlign: 'center'}}>
                <Typography>{t('tips.faq')}</Typography>
            </Box>
            <Box
                sx={{
                    maxWidth: '200px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '25px',
                    marginBottom: '50px',
                }}
            >
                <ImportantLink href={'/help/faq'}>{t('action.faq')}</ImportantLink>
            </Box>
            {!wasSent && (
                <SupportForm
                    categories={data}
                    campaignId={null}
                    onSubmitted={() => setWasSent(true)}
                />
            )}
            {wasSent && <EmailWasSentMessage />}
        </Page>
    );
}

export type SupportStaticProps = {
    data: SupportCategory[];
};

export const getStaticProps: GetStaticProps<SupportStaticProps> = async (context) => {
    const translation = await serverSideTranslations(context.locale, ['common']);
    try {
        // console.log('context.locale = ', context.locale);

        let url = URL_SERVER_INTERNAL + '/support';
        let requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const result = await fetch(url, requestOptions);
        const json = await result.json();

        return {
            props: {
                ...translation,
                data: json,
            },
            revalidate: 5,
        };
    } catch (e) {
        console.log('getServerSideProps::error support', e);
        return {
            props: {
                ...translation,
                data: null,
            },
            revalidate: 5,
        };
    }
};
